<div class="flex flex-row justify-content-between topbar-container px-3 py-2">
  <div
    class="absolute gap-3 flex left-5 via-input-txt font-bold"
    [ngClass]="{
      invisible: !titleService.getTitle()
    }"
  >
    <div>
      <i
        *ngIf="!sidebarService.isAlwaysOpen()"
        class="pi pi-bars color-primary text-lg cursor-pointer"
        (click)="sidebarService.toggle()"
      ></i>
    </div>
    {{ titleService.getTitle() }}
  </div>
</div>
